import React, { Component } from 'react';
import '../responsive/Conozcanos.css';
import MensajeF from '../components/Mensaje_Flotante/MensajeF';
import Footer from '../components/Principal/Footer';
import Header from '../components/Principal/Header';
import Seccion1 from '../components/Conozcanos/Seccion1';
import Seccion2 from '../components/Conozcanos/Seccion2';

class Conozcanos extends Component {
    constructor(props) {
        super(props);
        this.state = {

        };
    }
    render() {
        return (
            <React.Fragment>
                <Header id={2} />
                <MensajeF />
                <Seccion1 />
                <Seccion2 />
                <Footer />
            </React.Fragment>
        );
    }
}

export default Conozcanos;